import ramp from "../../../../SMARTCITY/assets/svg/rampes_amea.svg";
import amea from "../../../../SMARTCITY/assets/svg/amea.svg";
import ameaBlack from "../../../../SMARTCITY/assets/svg/ameaBlack.svg";
import other from "../../../../SMARTCITY/assets/svg/allo_amea.svg";
import lift from "../../../../SMARTCITY/assets/svg/anelkistires_amea.svg";
import crossing from "../../../../SMARTCITY/assets/svg/diavasi_tiflon.svg";
import lights from "../../../../SMARTCITY/assets/svg/fanari_amea.svg";
import changingRoom from "../../../../SMARTCITY/assets/svg/apoditiria_amea.svg";
import pavement from "../../../../SMARTCITY/assets/svg/pezodromia_amea.svg";
import defaultMarkerIcon from "../../../../SMARTCITY/assets/svg/default_marker.svg";
import defaultRoutesUserIcon from "../../../../SMARTCITY/assets/svg/default_routes_user.svg";
import defaultRoutesIcon from "../../../../SMARTCITY/assets/svg/default_routes.svg";
import filterIcon from "../../../../SMARTCITY/assets/svg/page_info.svg";
import blurred from "../../../../SMARTCITY/assets/images/blured.png";
import rightArrowIcon from "../../../../SMARTCITY/assets/svg/right_arrow_icon.svg";
import rightArrowIconBlack from "../../../../SMARTCITY/assets/svg/right_arrow_icon black.svg";
import closeIcon from "../../../../SMARTCITY/assets/svg/close_icon.svg";
import addCircleIcon from "../../../../SMARTCITY/assets/svg/add_circle.svg";
import greenMarkIcon from "../../../assets/icons/Map/green_mark_icon.svg";
import purpleMarkIcon from "../../../assets/icons/Map/purple_type_icon.svg";
import loginIcon from "../../../../SMARTCITY/assets/svg/login.svg";
import myLocationIcon from "../../../../SMARTCITY/assets/svg/my_location.svg";
import myLocationMarkerIcon from "../../../../SMARTCITY/assets/svg/my_location_marker.svg";
import locationOnIcon from "../../../../SMARTCITY/assets/svg/location_on.svg";
import locationOnMarkerIcon from "../../../../SMARTCITY/assets/svg/location_on_marker.svg";
import baseMarkerIcon from "../../../../SMARTCITY/assets/svg/base_marker.svg";
import searchIcon from "../../../../SMARTCITY/assets/svg/search.svg";
import bgImage from "../../../../SMARTCITY/assets/images/backgroundCity.png";
import threeDGismoLightIcon from "../../../../SMARTCITY/assets/svg/3d_gismo.svg";
import threeDGismoDarkIcon from "../../../../SMARTCITY/assets/svg/3d_gismo_black.svg";
import successIcon from "../../../../SMARTCITY/assets/svg/success_icon.svg";
import failureIcon from "../../../../SMARTCITY/assets/svg/failure_icon.svg";
import ameaRampIcon from "../../../../SMARTCITY/assets/svg/accessibility.svg";

export const dRamp = ramp;
export const dAmea = amea;
export const dAmeaBlack = ameaBlack;
export const dOther = other;
export const dLift = lift;
export const dCrossing = crossing;
export const dLights = lights;
export const dChangingRoom = changingRoom;
export const dPavement = pavement;
export const blurredImage = blurred;
export const defaultMarker = defaultMarkerIcon;
export const defaultRoutes = defaultRoutesIcon;
export const defaultRoutesUser = defaultRoutesUserIcon;
export const filter = filterIcon;
export const rightArrow = rightArrowIcon;
export const rightArrowBlack = rightArrowIconBlack;
export const close = closeIcon;
export const addCircle = addCircleIcon;
export const greenMark = greenMarkIcon;
export const purpleMark = purpleMarkIcon;
export const login = loginIcon;
export const myLocation = myLocationIcon;
export const myLocationMarker = myLocationMarkerIcon;
export const locationOn = locationOnIcon;
export const locationOnMarker = locationOnMarkerIcon;
export const baseMarker = baseMarkerIcon;
export const search = searchIcon;
export const bgImg = bgImage;
export const threeDGismo = threeDGismoLightIcon;
export const threeDGismoDark = threeDGismoDarkIcon;
export const success = successIcon;
export const failure = failureIcon;
export const ameaRamp = ameaRampIcon;
